<template>
  <SocialMarketingCardContainer :inProgress="inProgress">
    <SocialMarketingImage
      class="flex-1"
      :userImage="marketingAsset.image"
      :gradient="backgroundGradient"
      :filterColor="brandBG(0.3)"
      :editMode="editMode"
    />
    <div
      class="flex-1 d-flex flex-column justify-content-between"
      :style="backgroundStyle"
    >
      <div class="card-p-3">
        <SocialMarketingStudioInfo
          class="mb-4"
          color="dark"
          :studioUrl="studioUrl"
        />
        <SocialMarketingStudioContent
          :title="marketingAsset.title"
          :description="marketingAsset.description"
        />
      </div>
    </div>
  </SocialMarketingCardContainer>
</template>

<script>
import SocialMarketingCardContainer from '@/web/components/marketing/SocialMarketingCardContainer.vue';
import SocialMarketingStudioInfo from '@/web/components/marketing/SocialMarketingStudioInfo.vue';
import SocialMarketingStudioContent from '@/web/components/marketing/SocialMarketingStudioContent.vue';
import SocialMarketingImage from '@/web/components/marketing/SocialMarketingImage.vue';
import { hex2rgba } from '@/core/api/utils/color-converter.ts';

export default {
  name: 'Template6',
  components: {
    SocialMarketingCardContainer,
    SocialMarketingStudioInfo,
    SocialMarketingStudioContent,
    SocialMarketingImage,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    inProgress: {
      type: Boolean,
      default: false,
    },
    isDownload: {
      type: Boolean,
      default: false,
    },
    studioUrl: {
      type: String,
      default: '',
    },
    backgroundGradient: {
      type: String,
      default:
        'linear-gradient(360deg, rgba(16, 22, 24, 0.80) 0%, rgba(16, 22, 24, 0.00) 100%)',
    },
    editMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    marketingAsset() {
      return this.value;
    },
    backgroundStyle() {
      return {
        backgroundColor: this.brandBG(0.1),
      };
    },
  },
  methods: {
    brandBG(opacity = 1) {
      return hex2rgba(this.marketingAsset?.primary_color, opacity);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
